// import downArrow from "./swap/down-arrow.png";
// import infoIcon from "./swap/info-icon.png";

const downArrow = require("./swap/down-arrow.png");
const infoIcon = require("./swap/info-icon.png");
const emptyCurrency = require("./swap/empty-currency.png");
const connectWhipserImage = require("./swap/connect-whisper.png");
const cancelIcon = require("./swap/cancel.png");

export { downArrow, infoIcon, emptyCurrency, connectWhipserImage, cancelIcon };
